export default {

}



// WEBPACK FOOTER //
// ./src/components/bank/store/mutations.js